import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess } from '../../redux/slices/adminSlice';
import { loginSuccessS } from '../../redux/slices/singleFarmSlice';

const useChangeFarm = () => {
    const {currentFarms}=useSelector(state=>state.farms);
    const dispatch=useDispatch()
    const changeFarm=(id)=>{
        const farm=currentFarms.find(item=>{
          return item?.id===id
        })
        console.log(farm)
        dispatch(loginSuccess(farm))
        dispatch(loginSuccessS(farm))
      }
  return {changeFarm}
}

export default useChangeFarm
